<template>

  <div class="fliter-wrapper " >
<!--    add class ib-->
    <div class="filter">
      <div class="fliter-content" v-bind:class="{filter_h_expend: isToggleFilter}">
        <div class="title d-flex">
          <div>{{$t('cFilter.filter')}}</div>
          <span v-if="filterIbWatchList.stops.some(stops => stops.by === 'user') ||filterIbWatchList.via.some(via => via.by === 'user')||  filterIbWatchList.depTime.some(depTime => depTime.by === 'user') ||
            filterIbWatchList.price.by === 'user'||filterIbWatchList.al.some(al => al.by === 'user')||
            filterIbWatchList.totalDuration.by === 'user'" @click="clearAllFilter(filterIbWatchList)">{{$t('cFilter.clearAll')}}</span>
        </div>

        <cFilterTag :currencyCode="GET_CURRENCY.code"
     @clearSelFilter="clearSelFilter" :dispFilterLs="dispFilterLs" @toToggleFilter="toggleFilter">
    </cFilterTag>
         <!-- <div v-if="dispFilterLs.length!=0">
          
        <div v-for="(items,index) in dispFilterLs" :key="'dispFilterLs'+items+index">
         
             <button @click="clearSelFilter(items)" class="w3-btn w3-grey">
               {{items.min?items.min+'-'+items.max:items.from?
              items.from+'-'+items.to:items.name?items.name:items.start+'-'+items.end}}
<span @click="clearSelFilter(items)" class="w3-badge w3-top-left">X</span>
</button> 
          
        </div> 
        </div> -->
      </div>
    
      <div class="fliter-content">
        <div class="fcontent-wrap">
          <div class="sub-title">
            <div>{{$t('cFilter.stop')}}</div>
            <span v-if="!isStopsForNonMyanmar && filterIbWatchList.via.some(via => via.by === 'user')" @click="clearFilter('via',filterIbWatchList)">{{$t('cFilter.clear')}}</span>
          <span v-if="isStopsForNonMyanmar && filterIbWatchList.stops.some(stops => stops.by === 'user')" @click="clearFilter('stops',filterIbWatchList)">{{$t('cFilter.clear')}}</span>
          </div>

          <cFilterStopsIb
                  v-if="isStopsForNonMyanmar"
                  class=" app-radio"
                  :filterIbWatList="filterIbWatchList"

                  @input="triggerCFilterFn"
          />
          <cFilterViaIb
          v-else
                  class=" app-radio"
                  :filterIbWatList="filterIbWatchList"

                  @input="triggerCFilterFn"
          />
        </div>

        <div  class="fcontent-wrap pb-15px">
          <div class="sub-title">
            <div>{{$t('cFilter.price')}}</div>
            <span v-if="filterIbWatchList.price.by === 'user'" @click="clearFilter('price',filterIbWatchList)">{{$t('cFilter.clear')}}</span>
          </div>
          <div class="filter-item">
            <div class="content">

              <cFilterPriceIb
                      v-on:input="triggerCFilterFn"
                      :filterIbWatList="filterIbWatchList"
              />
            </div>

          </div>
        </div>
        <div  class="fcontent-wrap pb-15px">
          <div class="sub-title">
            <div>{{$t('cFilter.duration')}}</div>
            <span v-if="filterIbWatchList.totalDuration.by === 'user'" @click="clearFilter('totalDuration',filterIbWatchList)">
            {{$t('cFilter.clear')}}</span>
          </div>
          <div class="filter-item">
            <div class="content">

              <cFilterDurIb
                      v-on:input="triggerCFilterFn"
                      :filterIbWatList="filterIbWatchList"
              />
            </div>
          </div>
        </div>

        <div class="fcontent-wrap duration">
          <div class="sub-title">
            <div>{{$t('cFilter.departureTimes')}}</div>
            <span v-if="filterIbWatchList.depTime.some(depTime => depTime.by === 'user')" @click="clearFilter('depTime',filterIbWatchList)">{{$t('cFilter.clear')}}</span>
          </div>
          <div class="filter-item">
            <div class="content">

              <cFilterIbDepTime
                      v-on:input="triggerCFilterFn"
                      :filterIbWatList="filterIbWatchList"
              />
            </div>

          </div>
        </div>
        <div class="fcontent-wrap airline">
          <div class="sub-title">
            <div>{{$t('flightResults.airlines')}}</div>
            <span v-if="filterIbWatchList.al.some(al => al.by === 'user')" @click="clearFilter('al',filterIbWatchList)">{{$t('cFilter.clear')}}</span>
          </div>
          <div class="filter-item">
            <div class="content">
              <cFilterALIb
                      v-on:input="triggerCFilterFn"
                      :filterIbWatList="filterIbWatchList"
              />
            </div>
          </div>
        </div>
      </div>
     


    </div>
  </div>
</template>
<script>
import BaseConfiguration from "../../config/base.js";

import cFilterViaIb from "../../components/result/cFilterViaIb";
import cFilterPriceIb from "../../components/result/cFilterPriceIb";
import cFilterStopsIb from "../../components/result/cFilterStopsIb";
import cFilterDurIb from "../../components/result/cFilterDurIb";
import cFilterALIb from "../../components/result/cFilterALIb";
import cFilterIbDepTime from "../../components/result/cFilterIbDepTime";
import Logger from "../../services/logger";
import { mapGetters, mapActions } from "vuex";
import {
  LOG_TYPE,
  FILE_NAME,
  HTTP_CODES,
  API_VALUES
} from "../../config/API_DATA";
import cFilterTag from "../../components/result/cFilterTag";
import {COMPONENT_NAME, FILTER, PATHNAME} from "../../util/constants";
import { cloneData } from "../../util/util";
export default {
  name: COMPONENT_NAME.C_ALL_FILTER_OB,
  components: {
    cFilterPriceIb,
    cFilterDurIb,
    cFilterStopsIb,
    cFilterALIb,
    cFilterViaIb,
    cFilterIbDepTime,
    cFilterTag
  },
  props: {
   
    filterIbWatList: {
      type: Object
    },
   isStopsForNonMyanmar: {
     type: Boolean
   },
   selIbFilterItems:{
     type: Object
   }
  },
  data: () => ({
    // flightResponse: [] | {},
    filterIbWatchList: {},
    isToggleFilter: false,
    dispFilterLs: []

  }),
  watch: {
       filterIbWatList:{
        immediate: false, 
        deep: true,
    handler: function (newVal, oldVal) {
      
      
       this.filterIbWatchList = this.filterIbWatList;
   
      }
      },
      
  },
  computed: {
    ...mapGetters("sResult", {
      GET_IB_DISP_FILTER_LS: "GET_IB_DISP_FILTER_LS",
      GET_CURRENCY: "GET_CURRENCY",
    }),
  },

  methods: {
    ...mapActions("sResult", {
      SET_IB_DISP_FILTER_LS:"SET_IB_DISP_FILTER_LS",
    }),

    ////only to display the applied filter in filter tag in ui
    toDispFilterTagLs(pFilterKey,pFilterObj) {
      let retValue;
        try {
          if(BaseConfiguration.isDebug) console.log("toDispFilterTagLs");
      
          if(pFilterKey=='al') {
             let alList=[];
        var finalAlLs=[];
              pFilterObj.al.filter(alObj => {
                if(alObj.status===1 && alObj.by === 'user'){
                 alList.push(alObj); 
                   this.dispFilterLs.push(alObj);
                }
                });
               if(alList.length==0){
         var aL = this.dispFilterLs.filter(function(objFromA) {
            return !pFilterObj.al.find(function(objFromB) {
                return objFromA.code === objFromB.code
                   })
                })
                this.dispFilterLs= aL;
              }else if(alList.length!=0){
               
                var c=[];
                var ls=[];
                var als=false;
                c = pFilterObj.al.filter(function(objFromA) {
            return !alList.find(function(objFromB) {
                return objFromA.code === objFromB.code
                   })
                })
                if(c.length!=0){
                for(let i=0;i<this.dispFilterLs.length;i++){
                  let j=0;   
                  if(this.dispFilterLs[i].name && c.length!=0) {
                     for(let j=0;j<c.length;j++) {
                  if(this.dispFilterLs[i].name!=c[j].name){
                    als=true;
                  }
                  else{
                    als=false;
                    break;
                  }
                   }
                   if(als==true) {
                     finalAlLs.push(this.dispFilterLs[i]);
                   }
                  }else{
                    finalAlLs.push(this.dispFilterLs[i]);
                  }
                }
                 }
                else{      /// if all the time obj is selected it is assigned to org list
                       for(let index=0;index<this.dispFilterLs.length;index++){
                 
                    finalAlLs.push(this.dispFilterLs[index]);
                       }
                  }
                let filter=[];
                
                 for(let i=0;i<finalAlLs.length;i++){
          if(finalAlLs[i].hasOwnProperty('status')){
            if(finalAlLs[i].status==1){
             
              if(filter.length!=0){
              if(!filter.includes(finalAlLs[i])){
              filter.push(finalAlLs[i]);
              }
              }else{
                 filter.push(finalAlLs[i]);
              }
              
            }
            
          }
          else if(finalAlLs[i].hasOwnProperty('min') || finalAlLs[i].hasOwnProperty('from')){
            filter.push(finalAlLs[i]);
          }
          }
          
         filter= Array.from(new Set(filter.map(JSON.stringify))).map(JSON.parse);
                this.dispFilterLs=filter;
                
               
              }
        
          }

          ///via
           if(pFilterKey=='via'){
       let viaLs=[];
              pFilterObj.via.filter(viaObj => {
                if(viaObj.status===1 && viaObj.by === 'user' ){
                   viaLs.push(viaObj);
                   this.dispFilterLs.push(viaObj);
                }
              })
       
                let viafilter=[];
          viafilter = this.dispFilterLs.filter(function(objFromA) {
            return !pFilterObj.via.find(function(objFromB) {
                return objFromA.code === objFromB.code
                   })
                });
                if(viaLs.length!=0 && viaLs[0].name!='All Stops'){
                viafilter.push(viaLs[0]);
                }
                
                this.dispFilterLs=viafilter;
           
        }
          ///stops
           if(pFilterKey=='stops'){
             let stopLs=[];
              pFilterObj.stops.filter(stopObj => {
                if(stopObj.status===1 && stopObj.by === 'user' ){
                   stopLs.push(stopObj);
                   this.dispFilterLs.push(stopObj);
                }
              })

                let stopfilter=[];
                stopfilter = this.dispFilterLs.filter(function(objFromA) {
            return !pFilterObj.stops.find(function(objFromB) {
                return objFromA.code === objFromB.code
                   })
                });
                if(stopLs.length!=0 && stopLs[0].name!='All Stops'){
                stopfilter.push(stopLs[0]);
                }
                
                this.dispFilterLs=stopfilter;
             

        }

        ///price
        if(pFilterKey=='price'){
          if(pFilterObj.price.by==='user'){
            let selPrice={
              min:0,
              max:0
            }
            selPrice.min = pFilterObj.price.from;
            selPrice.max = pFilterObj.price.to;
           let fil= this.dispFilterLs.filter(Obj => !Obj.hasOwnProperty('min'))
          
           fil.push(selPrice);
           this.dispFilterLs=fil;
          } else if(pFilterObj.price.by==='default') {
            let fil= this.dispFilterLs.filter(Obj => !Obj.hasOwnProperty('min'))
           this.dispFilterLs=fil;
          }
        }
        if(pFilterKey=='totalDuration'){
          let Durfil=[];
          if(pFilterObj.totalDuration.by==='user'){
            let selDur={
              from:0,
              to:0
            }
            selDur.from = this.$options.filters.convertToHrMin(pFilterObj.totalDuration.from,"minutes","H [h] mm [m]");
            selDur.to = this.$options.filters.convertToHrMin(pFilterObj.totalDuration.to,"minutes","H [h] mm [m]");
            Durfil= this.dispFilterLs.filter(Obj => !Obj.hasOwnProperty('from'))
           Durfil.push(selDur);
           this.dispFilterLs=Durfil;
          } else if(pFilterObj.totalDuration.by==='default'){
            Durfil= this.dispFilterLs.filter(Obj => !Obj.hasOwnProperty('from'))
          Durfil= Array.from(new Set(Durfil.map(JSON.stringify))).map(JSON.parse);
           this.dispFilterLs=Durfil;
          }
        }
        ///depTime
        let timeList=[];
         if(pFilterKey=='depTime') {
             var finaltimeLs=[];
            ///getting applied filter from filterwatchlist
              pFilterObj.depTime.filter(depTimeObj => {
                if(depTimeObj.status===1 && depTimeObj.by === 'user'){
                   timeList.push(depTimeObj);          ///user selected time obj
                 this.dispFilterLs.push(depTimeObj);    /// selected time obj will be added 
                }
              })
              /// if there is no time filter applied
              if(timeList.length==0){
                /// to delete if any time obj present already
                for(let index=0;index<this.dispFilterLs.length;index++){
                 if(!this.dispFilterLs[index].start) {
                    finaltimeLs.push(this.dispFilterLs[index]);
                 }}
              }

              /// if any time filter is selected
              else if(timeList.length!=0){
               
                var c=[];
                var ls=[];
                var tls=false;

                ///to get time obj which is deselcted/cleared/not selected
                c = pFilterObj.depTime.filter(function(objFromA) {
            return !timeList.find(function(objFromB) {
                return objFromA.start === objFromB.start
                   })
                })

                /// to remove the deselected time obj from the original list
                 if(c.length!=0){
                 
                for(let i=0;i<this.dispFilterLs.length;i++){  
                  let j=0;               
                  if(this.dispFilterLs[i].start) {
                     for(let j=0;j<c.length;j++) {
                  if(this.dispFilterLs[i].start!=c[j].start){
                    tls=true;
                  }
                  else{
                    tls=false;
                    break;
                  }
                   }
                   if(tls==true) {
                     finaltimeLs.push(this.dispFilterLs[i]);
                   }
                  }else{
                    finaltimeLs.push(this.dispFilterLs[i]);
                  }
                  }
                 
                }
                else{      /// if all the time obj is selected it is assigned to org list
                       for(let index=0;index<this.dispFilterLs.length;index++){
                 
                    finaltimeLs.push(this.dispFilterLs[index]);
                       }
                  }
              }
                let timefilter=[];

                /// to check the status of the obj in org ls and add to the temp list
                 for(let t=0;t<finaltimeLs.length;t++){
          if(finaltimeLs[t].hasOwnProperty('status')){
            if(finaltimeLs[t].status==1){
              
              if(timefilter.length!=0){
              if(!timefilter.includes(finaltimeLs[t])){
              timefilter.push(finaltimeLs[t]);
              }
              }else{
                 timefilter.push(finaltimeLs[t]);
              }
            }
            
          }
          else if(finaltimeLs[t].hasOwnProperty('min') || finaltimeLs[t].hasOwnProperty('from')){
            timefilter.push(finaltimeLs[t]);
          }
          }

          /// to remove duplicate and to get unique obj
           timefilter= Array.from(new Set(timefilter.map(JSON.stringify))).map(JSON.parse);
                this.dispFilterLs=timefilter;
              }
          this.SET_IB_DISP_FILTER_LS(this.dispFilterLs);
     
        } catch (err) {
                let body = Logger.buildRequest(
                  FILE_NAME.C_ALL_FILTER_IB,
                  "error in toDispFilterTagLs",
                  err.toString(),
                  "toDispFilterTagLs",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          return retValue;
  },
    toggleFilter(pToggleFilter) {
      try {
        if (BaseConfiguration.isDebug) console.log("isToggleFilter");

        this.isToggleFilter = pToggleFilter;

      } catch (err) {
        let body = Logger.buildRequest(
                PATHNAME.FLIGHTRESULTS,
                "error while modifing search",
                err.toString(),
                "isToggleFilter",
                LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
  clearSelFilter(pFilterName) {
    let retValue;
      try {
        if(BaseConfiguration.isDebug) console.log("clearSelFilter");
        if(pFilterName.min){
          retValue='price';
          this.clearFilter(retValue,this.filterIbWatchList);
          
        }else if(pFilterName.from){
          retValue='totalDuration';
          this.clearFilter(retValue,this.filterIbWatchList);
         
        }else if(!this.isStopsForNonMyanmar && this.filterIbWatchList.via.some(via => via.name === pFilterName.name)){
          this.clearFilter('via',this.filterIbWatchList);
          
        }else if(this.isStopsForNonMyanmar && this.filterIbWatchList.stops.some(stops => stops.name === pFilterName.name)){
          this.clearFilter('stops',this.filterIbWatchList);
         
        }else if(this.filterIbWatchList.al.some(al => al.name === pFilterName.name)){
          this.filterIbWatchList.al.filter(alObj => {
            if(alObj.name===pFilterName.name){
              alObj.status=0;
              alObj.by='default'
            }else{
              alObj.status=1;
            }
          })
          this.toDispFilterTagLs('al',this.filterIbWatchList);
          
           this.$emit(
            "cAllFilterIBFn",
           this.filterIbWatchList
          );
          // this.$emit(
          //  "getFilterTag",
          //  this.dispFilterLs
          // );
        }
        else if(this.filterIbWatchList.depTime.some(depTime => depTime.start === pFilterName.start)){
          this.filterIbWatchList.depTime.filter(depTimeObj => {
            if(depTimeObj.start===pFilterName.start){
              depTimeObj.status=0;
              depTimeObj.by='default'
            }else{
              depTimeObj.status=1;
            }
          })
          this.toDispFilterTagLs('depTime',this.filterIbWatchList);
          
           this.$emit(
            "cAllFilterIBFn",
           this.filterIbWatchList,
           );
          // this.isToggleFilter=false;
        //   this.$emit(
        //    "getFilterTag",
        //    this.dispFilterLs
        //   );
        }
        
       
      } catch (err) {
              let body = Logger.buildRequest(
                FILE_NAME.C_ALL_FILTER_IB,
                "error in clearSelFilter",
                err.toString(),
                "clearSelFilter",
                LOG_TYPE.ERROR
              );
              Logger.getResponse(body);
            }
        // return retValue;
 }, 

triggerCFilterFn( pSelFilterVal, pFilComp) {
      try {
        if (BaseConfiguration.isDebug) console.log("triggerCFilterFn");
       

        let retFilWatchList;
        if (pFilComp == FILTER.C_FILTER_AL) {
          retFilWatchList = this.updateFilWatchList(
            pSelFilterVal,
            this.filterIbWatchList,
            pFilComp
          );
          if (retFilWatchList) {
            this.filterIbWatchList = retFilWatchList;
            this.toDispFilterTagLs('al',this.filterIbWatchList);
          }
        } else if (pFilComp == FILTER.C_FILTER_PRICE) {
          retFilWatchList = this.updateFilWatchList(
            pSelFilterVal,
            this.filterIbWatchList,
            pFilComp
          );
          if (retFilWatchList) {
            this.filterIbWatchList = retFilWatchList;
             this.toDispFilterTagLs('price',this.filterIbWatchList);
          }
        } else if (pFilComp == FILTER.C_FILTER_STOPS) {
          retFilWatchList = this.updateFilWatchList(
            pSelFilterVal,
            this.filterIbWatchList,
            pFilComp
          );
          if (retFilWatchList) {
            this.filterIbWatchList = retFilWatchList;
            this.toDispFilterTagLs('stops',this.filterIbWatchList);
          }
        }
        else if (pFilComp == FILTER.C_FILTER_VIA) {
          retFilWatchList = this.updateFilWatchList(
            pSelFilterVal,
            this.filterIbWatchList,
            pFilComp
          );
          if (retFilWatchList) {
            this.filterIbWatchList = retFilWatchList;
            this.toDispFilterTagLs('via',this.filterIbWatchList);
          }
        }
        else if (pFilComp == FILTER.C_FILTER_DUR) {
          retFilWatchList = this.updateFilWatchList(
            pSelFilterVal,
            this.filterIbWatchList,
            pFilComp
          );
          if (retFilWatchList) {
            this.filterIbWatchList = retFilWatchList;
             this.toDispFilterTagLs('totalDuration',this.filterIbWatchList);
          }
        }else if (pFilComp == FILTER.C_FILTER_DEPTIME) {
          retFilWatchList = this.updateFilWatchList(
            pSelFilterVal,
            this.filterIbWatchList,
            pFilComp
          );
          if (retFilWatchList) {
            this.filterIbWatchList = retFilWatchList;
            this.toDispFilterTagLs('depTime',this.filterIbWatchList);
            
          }
        }

         this.$emit(
            "cAllFilterIBFn",
           this.filterIbWatchList,
          );
          // this.$emit(
          //  "getFilterTag",
          //  this.dispFilterLs
          // );
        
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_ALL_FILTER,
          "error in triggerCFilterFn",
          err.toString(),
          "triggerCFilterFn",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
 },



    

    

    updateFilWatchList(pFilterValue, pFilterIbWatchList, pFilterComp) {
      try {
        if (BaseConfiguration.isDebug) console.log("updateFilWatchList");
        let retFilterWatchls = {};

        if (pFilterIbWatchList) {
          retFilterWatchls = pFilterIbWatchList;
        }
        retFilterWatchls[pFilterComp] = pFilterValue;
        return retFilterWatchls;

      
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_ALL_FILTER,
          "error in updateFilWatchList",
          err.toString(),
          "updateFilWatchList",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

        clearAllFilter(pFilterObj) {
     
        try {
          if(BaseConfiguration.isDebug) console.log("clearAllFilter");
       
         for(var i in pFilterObj){
            if(pFilterObj[i].length && pFilterObj[i].length!=0) {
             for(let j=0;j<pFilterObj[i].length;j++){
               if(i==FILTER.C_FILTER_AL){
               pFilterObj[i][j].status=0;
               pFilterObj[i][j].by='default';
               this.toDispFilterTagLs(i,this.filterIbWatchList);
               }else if(i==FILTER.C_FILTER_DEPTIME){
               pFilterObj[i][j].status=0;
               pFilterObj[i][j].by='default';
               this.toDispFilterTagLs(i,this.filterIbWatchList);
               }
             else if(i==FILTER.C_FILTER_VIA) {
                 if(j==0) {
                 pFilterObj[i][j].status=1;
                 }else{
                    pFilterObj[i][j].status=0;
                 }
                 pFilterObj[i][j].by='default';
               }
                else if(i==FILTER.C_FILTER_STOPS) {
                 if(j==0) {
                 pFilterObj[i][j].status=1;
                 }else{
                    pFilterObj[i][j].status=0;
                 }
                 pFilterObj[i][j].by='default';
               }
            }
            
            this.toDispFilterTagLs(i,this.filterIbWatchList);
            }
            else{
              if(i==FILTER.C_FILTER_PRICE){
                pFilterObj[i].from=pFilterObj[i].min;
                pFilterObj[i].to=pFilterObj[i].max;
                 pFilterObj[i].by='default';
                 this.toDispFilterTagLs(i,this.filterIbWatchList);
              }else if(i==FILTER.C_FILTER_DUR){
                // if(pFilterObj[i].start==pFilterObj[i].end){
                //   pFilterObj[i].from=0;
                // pFilterObj[i].to=pFilterObj[i].end;
                // pFilterObj[i].by='default';
                // this.toDispFilterTagLs(i,this.filterIbWatchList);
                // }else{
                  pFilterObj[i].from=pFilterObj[i].start;
                pFilterObj[i].to=pFilterObj[i].end;
                pFilterObj[i].by='default';
                this.toDispFilterTagLs(i,this.filterIbWatchList);
               // }
                
              }
            }
         }
         this.$emit(
            "cAllFilterIBFn",
           pFilterObj,
           );
           this.isToggleFilter=false;
          // this.$emit(
          //  "getFilterTag",
          //  this.dispFilterLs
          // );
        } catch (err) {
                let body = Logger.buildRequest(
                  FILE_NAME.C_ALL_FILTER_IB,
                  "error in clearAllFilter",
                  err.toString(),
                  "clearAllFilter",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          
  },

    clearFilter(pFilter, pFilterObj) {
      // let retValue;
        try {
          if(BaseConfiguration.isDebug) console.log("clearFilter");
          
            if(pFilterObj[pFilter].length && pFilterObj[pFilter].length!=0) {
             for(let j=0;j<pFilterObj[pFilter].length;j++){
               if(pFilter==FILTER.C_FILTER_AL) {
               pFilterObj[pFilter][j].status=0;
               pFilterObj[pFilter][j].by='default';
               this.toDispFilterTagLs(pFilter,this.filterIbWatchList);
               }else if(pFilter==FILTER.C_FILTER_DEPTIME){
               pFilterObj[pFilter][j].status=0;
                pFilterObj[pFilter][j].by='default';
                this.toDispFilterTagLs(pFilter,this.filterIbWatchList);
               }
               else if(pFilter==FILTER.C_FILTER_VIA) {
                 if(j==0) {
                 pFilterObj[pFilter][j].status=1;
                 }else{
                    pFilterObj[pFilter][j].status=0;
                 }
                 pFilterObj[pFilter][j].by='default';
                 this.toDispFilterTagLs(pFilter,this.filterIbWatchList);
               }
               else if(pFilter==FILTER.C_FILTER_STOPS) {
                 if(j==0) {
                 pFilterObj[pFilter][j].status=1;
                 }else{
                    pFilterObj[pFilter][j].status=0;
                 }
                 pFilterObj[pFilter][j].by='default';
               }
               this.toDispFilterTagLs(pFilter,this.filterIbWatchList);
             }
             
            }
            else{
              if(pFilter==FILTER.C_FILTER_PRICE){
                pFilterObj[pFilter].from=pFilterObj[pFilter].min;
                pFilterObj[pFilter].to=pFilterObj[pFilter].max;
                pFilterObj[pFilter].by='default';
                this.toDispFilterTagLs(pFilter,this.filterIbWatchList);
              }else if(pFilter==FILTER.C_FILTER_DUR){
                if(pFilterObj[pFilter].start==pFilterObj[pFilter].end) {
                  pFilterObj[pFilter].from=2;
                pFilterObj[pFilter].to=pFilterObj[pFilter].end-pFilterObj[pFilter].end*FILTER.SOFTLIMIT_VAL/100;
                 pFilterObj[pFilter].by='default';
                 this.toDispFilterTagLs(pFilter,this.filterIbWatchList);
                }else{
                  pFilterObj[pFilter].from=pFilterObj[pFilter].start;
                pFilterObj[pFilter].to=pFilterObj[pFilter].end;
                pFilterObj[pFilter].by='default';
                this.toDispFilterTagLs(pFilter,this.filterIbWatchList);
                }
                
              }
            }
          
          this.$emit(
            "cAllFilterIBFn",
           pFilterObj,
           );
          // this.$emit(
          //  "getFilterTag",
          //  this.dispFilterLs
          // );
        } catch (err) {
                let body = Logger.buildRequest(
                  FILE_NAME.C_ALL_FILTER_OB,
                  "error in clearFilter",
                  err.toString(),
                  "clearFilter",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          // return retValue;
  }, 

    // clearAllFilterAction(pFilCompIb) {
    //   try {
    //     if (BaseConfiguration.isDebug) console.log("clearAllFilterAction");
    //     this.$root.$emit("clearAllIbFilterFn", pFilCompIb);
    //     // let watchlist=this.filterWatchList[0];
    //     // if(pFilCompIb==$t('flightResults.airlines'))
    //     // {
    //     // this.$delete(watchlist,FILTER.C_FILTER_AL_OB);
    //     // }

    //     // // for(let i=0;i<watchlist.length;i++){
    //     //       this.$root.$emit("cFilterALIbFn", this.flightRes);

    //     // }
    //   } catch (err) {
    //     let body = Logger.buildRequest(
    //       COMPONENT_NAME.C_ALL_FILTER,
    //       "error in clearAllFilterAction",
    //       err.toString(),
    //       "clearAllFilterAction",
    //       LOG_TYPE.ERROR
    //     );
    //     Logger.getResponse(body);
    //   }
    // },
   
    // updateFilteredValues(pFilterIbWatchList, pflightRes) {
    //   try {
    //     if (BaseConfiguration.isDebug) console.log("updateFilteredValues");
    //     let retFilteredIbList = pFilterIbWatchList;

    //     if (retFilteredIbList) {
    //       for (let i = 0; i < Object.keys(retFilteredIbList).length; i++) {
    //         if (Object.keys(retFilteredIbList)[i] == FILTER.C_FILTER_AL) {
    //           retFilteredIbList[
    //             Object.keys(retFilteredIbList)[i]
    //           ] = Object.values(this.airlines);
    //           for (
    //             let j = 0;
    //             j < retFilteredIbList[Object.keys(retFilteredIbList)[i]].length;
    //             j++
    //           ) {
    //             for (let k = 0; k < Object.keys(this.airlines).length; k++) {
    //               if (
    //                 Object.values(this.airlines)[k].airline_name ==
    //                 retFilteredIbList[Object.keys(retFilteredIbList)[i]][j]
    //                   .airline_name
    //               ) {
    //                 retFilteredIbList[Object.keys(retFilteredIbList)[i]][
    //                   j
    //                 ].code = Object.keys(this.airlines)[k];
    //               }
    //             }
    //           }
    //         }
    //         if (Object.keys(retFilteredIbList)[i] == FILTER.C_FILTER_PRICE) {
    //           let retPriceLs = this.updatePriceLs(pflightRes);
    //           retFilteredIbList[
    //             Object.keys(retFilteredIbList)[i]
    //           ].min = Math.min.apply(Math, retPriceLs);
    //           retFilteredIbList[
    //             Object.keys(retFilteredObList)[i]
    //           ].max = Math.max.apply(Math, retPriceLs);
    //         }
    //         if (Object.keys(retFilteredObList)[i] == FILTER.C_FILTER_STOPS) {
    //           let retStopsLs = this.getStops(pflightRes);
    //           retFilteredObList[Object.keys(retFilteredObList)[i]] = retStopsLs;
    //         }
    //       }
    //     }
    //     return retFilteredObList;
    //   } catch (err) {
    //     let body = Logger.buildRequest(
    //       COMPONENT_NAME.C_ALL_FILTER,
    //       "error in updateFilteredValues",
    //       err.toString(),
    //       "updateFilteredValues",
    //       LOG_TYPE.ERROR
    //     );
    //     Logger.getResponse(body);
    //   }
    // }
  },
  created() {
    try {
      if (BaseConfiguration.isDebug) console.log("created");
     
      this.filterIbWatchList = this.filterIbWatList;
      if(this.GET_IB_DISP_FILTER_LS && this.GET_IB_DISP_FILTER_LS.length!=0){
        this.dispFilterLs=this.GET_IB_DISP_FILTER_LS;
      }
      // this.flightResponse = this.flightRes;
      // if(!this.isUpdateWatCalled)
      // {
      // let retFilteredIbValues = this.updateFilteredValues(
      //   this.filterIbWatchList,
      //   this.flightResponse
      // );
      // if (retFilteredIbValues) {
      //   this.filterIbWatchList = retFilteredIbValues;
      // }
      // }
    } catch (err) {
      let body = Logger.buildRequest(
        COMPONENT_NAME.C_ALL_FILTER,
        "error in created",
        err.toString(),
        "created",
        LOG_TYPE.ERROR
      );
      Logger.getResponse(body);
    }
  }
};
</script>
